import { Input, Button, Tag } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { TFieldOptionsEditorProps } from '@/types/TSmartCRM';

export const FieldOptionsEditor = ({
	value = [],
	onChange,
	disabled = false,
}: TFieldOptionsEditorProps) => {
	const [newOption, setNewOption] = useState('');

	const addOption = () => {
		if (newOption.trim() && !value.includes(newOption.trim())) {
			const updatedOptions = [...value, newOption.trim()];
			onChange?.(updatedOptions);
			setNewOption('');
		}
	};

	const removeOption = (optionToRemove: string) => {
		const updatedOptions = value.filter((option) => option !== optionToRemove);
		onChange?.(updatedOptions);
	};

	const handleKeyPress = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			addOption();
		}
	};

	return (
		<div className="space-y-3">
			<div className="flex gap-2">
				<Input
					placeholder="Add an option..."
					value={newOption}
					onChange={(e) => setNewOption(e.target.value)}
					onKeyPress={handleKeyPress}
					className="flex-1"
					disabled={disabled}
				/>
				<Button
					type="primary"
					icon={<PlusOutlined />}
					onClick={addOption}
					disabled={!newOption.trim() || disabled}
				>
					Add
				</Button>
			</div>

			{value.length > 0 && (
				<div className="border border-gray-200 rounded-lg p-3 bg-gray-50">
					<div className="flex flex-wrap gap-2">
						{value.map((option) => (
							<Tag
								key={option}
								closable={!disabled}
								onClose={() => removeOption(option)}
								closeIcon={<CloseOutlined />}
								className="px-3 py-1 text-sm"
							>
								{option}
							</Tag>
						))}
					</div>
				</div>
			)}
		</div>
	);
};
